import { config } from '@/config';
export const userState = {
    currentUser: undefined,
    personalSpaces: undefined,
    selectedLanguage: config.value.defaultLanguage,
};
